import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { UserService } from 'src/app/services/core/users/user.service';
import { VarificationService } from 'src/app/services/core/varifications/varification.service';
import { sweetAlert } from 'src/app/utils/swal';
import { onTimeChange, vehicleVerificationLabels, scrollToDocumentField } from 'src/app/utils/utils.common';
@UntilDestroy()

@Component({
  selector: 'app-vehicle-verification',
  templateUrl: './vehicle-verification.component.html',
  styleUrls: ['./vehicle-verification.component.css']
})
export class VehicleVerificationComponent implements OnInit {

  @Input() vehicleObj: any;
  @Input() scrollToField: any;
  @Input() highlightStatus: any;
  @Output() closeModal = new EventEmitter<any>
  vehicleForm!: FormGroup;
  vehicleVarificationForm!: FormGroup;
  approvalForm!: FormGroup;
  isAllControlsTrue: boolean = false;
  companyId: any
  vehicleData: any;
  users: any;
  spacetypesList:any;
  submitted = false;
  preSpaceType:any;
  serviceAreaName:any = []
  showRejectReasonModal: boolean = false;
  rejectingDocumentLabel: string = '';
  rejectingSection: string = '';
  rejectingField: string = '';
  rejectingControlPath: string = '';
  rejectingGroupName: string = '';
  rejectingControlName: string = '';
  rejectedReasons: { [key: string]: string } = {};
  sectionLabels: { [key: string]: string } = {
    images: 'documents',
    dates: 'documents',
  };
  fieldGroupMap: { [key: string]: string } = {
    registration: 'images',
    inspectionReport: 'images',
    vehicle: 'images',
    back: 'images',
    left: 'images',
    right: 'images',
    registrationDate: 'dates',
    registrationExpireDate: 'dates',
    inspectionDate: 'dates',
    inspectionExpireDate: 'dates',
  };

  constructor(
    private spaceTypeService : SpaceTypeService,
    private userService: UserService,
    private cedentialService: CredentialService,
    private varificationSerice: VarificationService,
    private router: Router,
    private fb: FormBuilder,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit(): void {
    this.vehicleForm = this.fb.group({
      description: [''],
      vin: [''],
      licensePlateNumber: [''],
      year: [''],
      make: [''],
      model: [''],
      color: [''],
      spaceType: [],
      garageAddress: this.fb.group({
        name: [''],
        coords: [''],
        city: [''],
        state: ['']
      }),
      serviceAreas: [''],
      images: this.fb.group({
        registration: [],
        inspectionReport: [],
        vehicle: [],
        back: [],
        left: [],
        right: [],
      }),
      dates: this.fb.group({
        registrationDate: [],
        registrationExpireDate: [],
        approvalDate: [moment().toISOString],
        inspectionDate: [],
        inspectionExpireDate: []
      }),
      company: ['']
    });

    this.vehicleVarificationForm = this.fb.group({
      isDescription: [false],
      isVin: [false],
      isLicensePlateNumber: [false],
      isYear: [false],
      isMake: [false],
      isModel: [false],
      isColor: [false],
      isSpaceType: [false],
      garageAddress: this.fb.group({
        isName: [false],
        isCity: [false],
        isState: [false],
      }),
      isServiceAreas: [false],
      images: this.fb.group({
        isRegistration: [false],
        isInspectionReport: [false],
        isVehicle: [false],
        isBack: [false],
        isLeft: [false],
        isRight: [false],
      }),
      dates: this.fb.group({
        isRegistrationDate: [false],
        isRegistrationExpireDate: [false],
        isInspectionDate: [false],
        isInspectionExpireDate: [false],
      }),
    });

    this.approvalForm = this.fb.group({
      isApproved: [false, Validators.required],
      approvedDate: ['', Validators.required],
      user: ['', Validators.required],
    });
    this.getUser();
    this.getSpaceType();
    console.log(this.vehicleForm)
  }

  getUser() {
    this.sharedDataService
    .getUser()
    .pipe(untilDestroyed(this)).subscribe(user => {
      if (user) {
        this.approvalForm.patchValue({
          user: user.id
        });
      }
    });
  }


  getVehicleById() {

    this.cedentialService.getVehicleById(this.vehicleObj.id).pipe(untilDestroyed(this)).subscribe((data: any) => {

      if (data) {
        this.vehicleData = data;
        this.rejectedReasons = this.showRejectReason(data.rejectionReasons);
         if(this.vehicleData.serviceAreas){
          this.serviceAreaName.push(...this.vehicleData.serviceAreas.split(',').map((area:any) => area.trim()));
        }
        const spaceTypeTitle = this.spacetypesList?.find(
          (st: any) => st.id === data.spaceType
        )?.title ?? data.spaceType;
        this.vehicleForm.patchValue({
          ...data,
          spaceType: spaceTypeTitle,
          dates: {
            ...data.dates,
            registrationDate: data.dates.registrationDate ? moment(data.dates.registrationDate).format('MM/DD/YYYY') : '',
            inspectionDate: data.dates.inspectionDate ? moment(data.dates.inspectionDate).format('MM/DD/YYYY') : '',
            registrationExpireDate: data.dates.registrationExpireDate ? moment(data.dates.registrationExpireDate).format('MM/DD/YYYY') : '',
            inspectionExpireDate: data.dates.inspectionExpireDate ? moment(data.dates.inspectionExpireDate).format('MM/DD/YYYY') : '',
          },
        })
        if (data.validationFlags) {
          this.vehicleVarificationForm.patchValue({
            ...data.validationFlags
          })
        }
        if (this.scrollToField) {
          scrollToDocumentField(this.scrollToField, 300, true, this.highlightStatus);
        }
      }
    })
  }

  onCloseModal() {
    this.closeModal.emit();
  }

  onSave() {
    if (this.vehicleVarificationForm.invalid) {
      return;
    }
    const payload = this.vehicleVarificationForm.value;
    this.varificationSerice.verifyVehicle(this.vehicleObj.id, payload).pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.vehicleData = data;
        this.patchValuesToForm(data)
        // this.onCloseModal();
      }
    })
  }

  patchValuesToForm(data: any) {
    this.rejectedReasons = this.showRejectReason(data.rejectionReasons);
    const spaceTypeTitle = this.spacetypesList?.find(
      (st: any) => st.id === data.spaceType
    )?.title ?? data.spaceType;
    this.vehicleForm.patchValue({
      ...data,
      spaceType: spaceTypeTitle,
      dates: {
        ...data.dates,
        registrationDate: data.dates.registrationDate ? moment(data.dates.registrationDate).format('MM/DD/YYYY') : '',
        inspectionDate: data.dates.inspectionDate ? moment(data.dates.inspectionDate).format('MM/DD/YYYY') : '',
        registrationExpireDate: data.dates.registrationExpireDate ? moment(data.dates.registrationExpireDate).format('MM/DD/YYYY') : '',
        inspectionExpireDate: data.dates.inspectionExpireDate ? moment(data.dates.inspectionExpireDate).format('MM/DD/YYYY') : '',
      },
    });
    this.approvalForm.patchValue(data);
    this.vehicleVarificationForm.patchValue({
      ...data.validationFlags
    })
  }

  setControl(control: AbstractControl, value: any): void {
    if (control) {
      control.setValue(value);
    }
  }

  toggleDisApprovedReasonModal(show: boolean, documentLabel: string = '', groupName: string = '', controlName: string = '') {
    this.showRejectReasonModal = show;
    this.rejectingDocumentLabel = documentLabel;
    if (controlName) {
      const rawField = controlName.replace(/^is/, '');
      this.rejectingField = rawField.charAt(0).toLowerCase() + rawField.slice(1);
      this.rejectingSection = this.sectionLabels[groupName] ?? groupName;
      this.rejectingControlPath = groupName ? `${groupName}.${controlName}` : controlName;
      this.rejectingGroupName = groupName;
      this.rejectingControlName = controlName;
    }
  }

  onRejectReasonSubmit(reason: string) {
    if (!this.vehicleData) {
      return;
    }
    const payload = {
      section: this.rejectingSection,
      field: this.rejectingField,
      approved: false,
      reason,
    };
    this.varificationSerice.disApprovedVehicleField(this.vehicleObj.id, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.setControl(this.vehicleVarificationForm.get(this.rejectingControlPath) as AbstractControl, false);
        this.rejectedReasons[this.rejectingControlPath] = reason;
        this.toggleDisApprovedReasonModal(false);
      }
    });
  }

  approveField(groupName: string, controlName: string) {
    if (!this.vehicleData) {
      return;
    }
    const rawField = controlName.replace(/^is/, '');
    const payload = {
      section: this.sectionLabels[groupName] ?? groupName,
      field: rawField.charAt(0).toLowerCase() + rawField.slice(1),
      approved: true,
      reason: '',
    };
    const path = groupName ? `${groupName}.${controlName}` : controlName;
    this.varificationSerice.disApprovedVehicleField(this.vehicleObj.id, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.setControl(this.vehicleVarificationForm.get(path) as AbstractControl, true);
        delete this.rejectedReasons[path];
      }
    });
  }

  showRejectReason(rejectionReasons: any): { [key: string]: string } {
    const result: { [key: string]: string } = {};
    if (!rejectionReasons) {
      return result;
    }
    Object.keys(rejectionReasons).forEach((group) => {
      const fields = rejectionReasons[group] || {};
      Object.keys(fields).forEach((field) => {
        const controlName = 'is' + field.charAt(0).toUpperCase() + field.slice(1);
        const subGroup = this.fieldGroupMap[field] ?? group;
        const path = subGroup ? `${subGroup}.${controlName}` : controlName;
        result[path] = fields[field]?.reason;
      });
    });
    return result;
  }

  getInvalidFields(): string[] {
    const formValues = this.vehicleVarificationForm.value;
    const labels: string[] = [];
    this.traverseForm(formValues, vehicleVerificationLabels, labels);
    return labels;
  }

  traverseForm(values: any, labelMap: any, labels: string[], prefix: string = ''): void {
    Object.keys(values).forEach(key => {
      if (typeof values[key] === 'object' && values[key] !== null) {
        // Check if labelMap[key] is an object, recursively call the function
        if (typeof labelMap[key] === 'object') {
          this.traverseForm(values[key], labelMap[key], labels, prefix);
        } else {
          this.traverseForm(values[key], labelMap[key], labels, prefix + labelMap[key] + ' - ');
        }
      } else if (values[key] === false) {
        labels.push(prefix + (labelMap[key] || key));
      }
    });
  }

  sendInvalidFieldsViaEmail(): void {
    const invalidFields = this.getInvalidFields();
    if (invalidFields.length > 0) {
      this.varificationSerice.vehicleInformationViaEmail(this.vehicleObj.id, invalidFields).pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data) {
          this.onCloseModal()
        }
      })
    }

  }

  checkNonValidFields() {
    const nonValidFields: any[] = [];

    const traverse = (obj: { [x: string]: any; }, path = "") => {
      for (const key in obj) {
        const value = obj[key];
        const currentPath = path ? `${path}.${key}` : key;

        if (!value) {
          nonValidFields.push(currentPath); // Store the full path of the invalid field
        }

        if (typeof value === "object" && value !== null) {
          traverse(value, currentPath); // Recurse for nested objects
        }
      }
    };
    traverse(this.vehicleData.validationFlags);
    traverse(this.vehicleVarificationForm.value);

    return nonValidFields;
  }


  onApproval() {
    this.submitted = true
    const isCurrentlyApproved = this.vehicleData?.isApproved;
    if (this.checkNonValidFields().length && !isCurrentlyApproved) {
      sweetAlert('Alert', `Some fields are missing.`, 'warning', 'OK')
      return;
    }
    const newApprovalState = !isCurrentlyApproved;
    if (this.approvalForm.invalid) {
      return;
    }

    this.approvalForm.patchValue({
      isApproved: newApprovalState
    })

    const payload = this.approvalForm.value;
    this.varificationSerice.approvedVehicle(this.vehicleObj.id, payload).pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.vehicleData = data;
        this.patchValuesToForm(data)
         this.closeModal.emit(data);
      }
    })
  }

  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName)
  }

  get form(): any {
    return this.vehicleVarificationForm.controls;
  }

  get garageAddress(): any {
    return this.vehicleVarificationForm.get('garageAddress') as FormGroup;
  }

  get images(): any {
    return this.vehicleVarificationForm.get('images') as FormGroup
  }

  get dates(): any {
    return this.vehicleVarificationForm.get('dates') as FormGroup
  }
  get approveForm() {
    return this.approvalForm.controls;
  }

  getSpaceType() {
    const queryParams = {
      limit: 999,
      
    }
    this.spaceTypeService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.spacetypesList = data.results;
        this.preSpaceType = this.spacetypesList.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});

        this.getVehicleById();
      }
    })
  }

}
